import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// offerta text
export const OFFERTA_TEXT = `Ёрдамга муҳтож аҳолига “Инсон учун” лойиҳаси доирасида ёрдам кўрсатиш бўйича

ШАРТНОМА (ОММАВИЙ ОФЕРТА)

Бир томондан нодавлат нотижорат ташкилоти (кейинги ўринларда “Фонд” деб юритилади) ва иккинчи томондан мазкур оммавий офертани бошқа бирор-бир шарт, истисно ва келишувларсиз қабул қилувчи (акцептловчи) ушбу ёрдамдан фойдаланувчи ёки унинг қонуний вакиллари (кейинги ўринларда “Бенефициар” деб юритилади) ижтимоий хизмат ва ёрдамларни кўрсатишни тартибга солувчи норматив-ҳуқуқий ҳужжатлар ҳамда бошқа қонунчилик ҳужжатларига амал қилиб, ушбу оммавий офертани туздилар:

I. Оммавий оферта предмети

1.1 Муҳтож шахс манфаатлари йўлида “Инсон учун” платформаси орқали хайрия маблағларини йиғиш ва сарфлаш тўғрисида бўлиб, томонларнинг ҳуқуқлари, мажбуриятлари ва жавобгарлигини белгилайди.

1.2 Фонд Бенефициар учун хайрия маблағларини йиғиш ва сарфлашни, ушбу жараёнларда шаффофликни таъминлашни ўз зиммасига олади.

II. Томонларнинг ҳуқуқ ва мажбуриятлари

2.1. Фонднинг ҳуқуқлари:

–бенефициар томонидан тақдим этилган ҳужжатларни ўрганиш, ҳаққонийлигини текшириш;

–бенефициарнинг ҳужжатларини ҳаққонийлиги ва ҳақиқатда муҳтожлиги тасдиқлангандан сўнг йиғим учун эълон қилиш, йиғинни рад этиш ёки йиғинни кечиктириш;

–зарур ҳолларда бенефициардан қўшимча маълумот, ҳужжат ва тушунтиришлар талаб қилиш;

–Фондга тақдим этилган фото, видео, матнли материаллардан Фонд фаолияти ва хайрия акцияларини оммалаштириш мақсадида ОАВ ва бошқа тармоқларда эълон қилиш ва фойдаланиш;

–салбий ҳуқуқий оқибатларга олиб келувчи ҳолатлар аниқланса, маблағ йиғишни бошлашни рад этиш ёки бошланган йиғишни тўхтатиб туриш;

–маблағ йиғиш тури, шакли, платформаси, медиада чоп этиш формати, матн, видеолар ва бошқа ахборот материалларини мустақил равишда танлаш;

–эҳтиёжи мўлжалланган суммадан камроқ маблағ талаб қилгани туфайли маблағлар ортиқча қолган тақдирда, қолган маблағларни бенефициарни огоҳлантирган ҳолда (розилик талаб қилинмайди) бошқа бенефициарларга йўналтириш;

–бенефициар томонидан мажбуриятларни бажармаган ёки бўйин товлаган тақдирда шартномани бир томонлама тартибда бекор қилиш.

2.2. Фонднинг мажбуриятлари:

–бенефициарнинг хайрия маблағларини йиғиш жараёнини амалдаги қонунчиликка, Фонд низомига ва мазкур шартнома шартларига мувофиқ тарзда ташкил этиш;

–бенефициар томонидан тақдим этилган ҳужжатлар, ҳисоб-фактуралар ва бошқа асословчи ҳужжатлар асосида мақсадли сарф режасини шакллантириш;

–йиғилган маблағларни фақат мақсадли равишда сарфлаш;

–йиғилган маблағлар ҳаракати бўйича бухгалтерия ҳисоби ва ички ҳисоботни юритиш, қонунчиликда белгиланган тартибда солиқ ва бошқа ҳисоботларни топшириш;

–бенефициар ёки унинг қонуний вакили талаби билан, умумий сарфлар тўғрисида қисқача маълумот, асосий тўловлар бўйича тасдиқловчи ҳужжатлар (ҳисоб-фактура, тўлов ҳужжатлари ва ҳ.к.) нусхасини тақдим этиш;

–маблағ йиғиш якунига етгани, мўлжалланган сумма тўлгани ёки бошқа сабабларга кўра тўхтатилгани ҳақида Бенефициарни ўз вақтида хабардор қилиш;

–Фонд платформаларида Бенефициар ҳақида маълумот берганда, унинг шаъни ва қадр-қимматини ҳурмат қилиш, камситувчи ёки салбий ифода ва материаллардан фойдаланмаслик.

2.3. Бенефициарнинг ҳуқуқлари:

–Фонддан йиғилган маблағлар ҳолати, асосий тўловлар ва даволаниш учун сарфланган суммалар бўйича қисқача маълумот (ҳисобот) сўраш;

–агар шахсий ёки оилавий сабабларга кўра кейинги хайрия йиғишни давом эттиришни истамаса, Фондга мурожаат қилиб, мaблaғ йиғишни тўхтатишни сўраш;

–Фонд фаолияти юзасидан ўз таклиф ва мулоҳазаларини киритиш, зарур деб топилган ҳолларда чақирувга биноан Фондга келиб, масалаларни юзма-юз муҳокама қилиш;

–мазкур шартнома шартларига риоя қилинмаган деб ҳисобласа, қонунчиликда белгиланган тартибда тегишли органларга мурожаат қилиш;

–агар эҳтиёжи тўлиқ қондирилган бўлса ёки бошқа манбадан тўлиқ молиялаштирилса, қолган маблағлар тақдири бўйича Фонд билан келишув асосида қарор қабул қилишда иштирок этиш.

–ўзига нисбатан инсонпарвар ва унинг қадр-қимматини камситмайдиган ҳамда иззат-ҳурмат билан муносабатда бўлинишини талаб қилиш;`;
